<div class="modal-header">
  <h5 class="modal-title">Save view</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
@if (!newViewMode) {
  @if (isViewEditable) {
    <div class="modal-body m-3">
      <p class="mb-0">Do you want to update {{ editedView.label }} or create a new one?</p>
    </div>
  }
  @if (!isViewEditable) {
    <div class="modal-body m-3">
      <p class="mb-0">Do you want to create a new view based on {{ editedView.label }}?</p>
    </div>
  }
  <div class="modal-footer text-center">
    @if (isViewEditable) {
      <chitin-button (clicked)="changeViewMode('update')" [label]="'Update ' + editedView.label" />
    }
    <chitin-button (clicked)="changeViewMode('create')" label="Create new" />
  </div>
}
@if (newViewMode) {
  <div class="modal-body m-3">
    <p class="mb-0">Please enter a name for this view</p>
    <chitin-form-input type="text" [value]="newViewLabel" (valueChange)="newViewLabel = $event" />
    @if (labelError) {
      <div class="text-danger mt-1" style="font-size: 75%">{{ labelError }}</div>
    }
  </div>
  <div class="modal-footer d-flex justify-content-between">
    <chitin-button (clicked)="changeViewMode(undefined)" [outline]="true" label="Back" />
    @if (newViewMode === 'create' && newViewLabel) {
      <chitin-button (clicked)="onCreateClicked()" [label]="'Save as ' + newViewLabel" />
    }
    @if (newViewMode === 'update' && newViewLabel) {
      <chitin-button (clicked)="onUpdateClicked()" [label]="'Update ' + newViewLabel" />
    }
  </div>
}
